module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "vw-multi-picker"
  }, [_c('div', {
    attrs: {
      "id": "targetContainer"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-edca2ff8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/picker.vue
// module id = 291
// module chunks = 0